import { handleRoute } from "../https";

export const downloadFile = async ({ fileId }) => {
  const res = await handleRoute({
    method: "get",
    path: `/public/v1/files/${fileId}`,
    payload: { responseType: "blob" },
  });
  return res;
};
